<template>
    <div>

        <!-- FILTER START -->
        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row outerBox filterBox">
                <div class="col row">
                    <div class="col-md-6 mobileFilterPaddingTop">
                        <label for="partshopCode">Search</label>
                        <div class="input-group">
                          <div class="input-group-prepend" style="height: 43px;">
                            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ options.searchFilter.find(x => x.value == filter.search_by).text }}&nbsp;<i class="fas fa-caret-down"></i></button>
                            <div class="dropdown-menu">
                              <a class="dropdown-item" v-for="opt in options.searchFilter" @click="filter.search_by = opt.value">{{ opt.text }}</a>
                            </div>
                          </div>
                          <input v-model="filter.search" type="text" class="form-control" aria-label="Text input with dropdown button" style="height: 43px;" :placeholder="'Type ' + options.searchFilter.find(x => x.value == filter.search_by).text">
                        </div>
                    </div>
                    <div class="col-md-3 mobileFilterPaddingTop">
                        <label>Status</label>
                        <MultiSelect
                            v-model="filter.status"
                            :options="options.status"
                            placeholder="Choose Status"
                        ></MultiSelect>
                    </div>
                    <div class="col-md-3 mobileFilterPaddingTop"
                        style="display: flex; flex-direction: column-reverse; padding-top:20px">
                        <button
                            type="button"
                            class="btn btn-primary"
                            style="height:38px; margin-bottom:0.5%"
                            @click="vue_universal_table.update++"
                        >Filter</button>
                    </div>
                </div>
            </div>
        </panel>
        <!-- FILTER END -->

        <div class="bg-white shadow box-content mt-5">
            <vue-universal-table
                api_url="/api/reports/qrcode"
                :infinite_scroll="true"
                :filter="filter"
                :fields="vue_universal_table.fields"
                :buttons="vue_universal_table.buttons"
                :update="vue_universal_table.update"

                sort_order="DESC"
                sort_by="created_at"

                @onDetail="openDetail"
            ></vue-universal-table>
        </div>

        <!-- Modal Start -->
        <qr-code-detail
            v-if="modal.detail"
            :id="modal.detailId"
            @closeModal="modal.detail = false"
        ></qr-code-detail>
        <!-- Modal End -->

    </div>
</template>

<script>
    import qrCodeDetail from './children/qrCodeDetailModal'

    export default {
        metaInfo : {
            title : 'Report QR Code'
        },
        data () {
            return {
                modal : {
                    detail : false,
                    detailId : null,
                },

                options : {
                    searchFilter : [
                        {text:'QR Code', value:'qrcode'},
                        {text:'Serial Number', value:'serial'}
                    ],
                    status : ['ACTIVE', 'INACTIVE', 'DEACTIVATED'],
                },
                filter : {
                    search : null,
                    search_by : 'qrcode',
                },
                vue_universal_table : {
                    fields : [
                        // {title:'URL', variable:'url', is_image: true},
                        {title:'QR Code', variable:'qrcode'},
                        {title:'Serial', variable:'serial_number'},
                        {title:'Status', variable:'status', style_condition : {
                            'ACTIVE' : 'color:green; font-weight:bold',
                            'INACTIVE' : 'color:orange; font-weight:bold',
                            'DEACTIVATED' : 'color:red; font-weight:bold',
                        }},
                        {title:'Created At', variable:'created_at', date_format:'DD MMM YYYY hh:mm:ss'},
                    ],
                    buttons : [
                        {title:'Detail', variable:'id', class:'btn-outline-info fas fa-link'}
                    ],
                    update : 0,
                },
            }
        },
        components : { 
            qrCodeDetail
        },
        mounted () {

        },
        methods : {
            openDetail (id) {
                this.modal.detailId = id.replace(/"/g, "");
                this.modal.detail = true;
            }
        }
    }
</script>

<style scoped>
    .box-content {
        padding: 20px;
        border-radius: 10px;
    }
</style>